import { render, staticRenderFns } from "./ForumResponseAvatar.vue?vue&type=template&id=b8e12832&scoped=true"
import script from "./ForumResponseAvatar.vue?vue&type=script&lang=js"
export * from "./ForumResponseAvatar.vue?vue&type=script&lang=js"
import style0 from "./ForumResponseAvatar.vue?vue&type=style&index=0&id=b8e12832&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e12832",
  null
  
)

export default component.exports